import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { routeParametersPropType } from './route-parameters-prop-type'
import { waypointsPropType } from './waypoints-prop-type'

/**
 * @typedef {Object} Route
 *
 * @property {string} [description] - route description
 * @property {number} [routeDistance] - route routeDistance
 * @property {number} [routeDuration] - route routeDuration
 * @property {string} [name] - route name
 * @property {Id} [routeId] - route id
 * @property {RouteParameters} [routeParameters] - route parameters, such as if it is fastest
 * @property {string} [type] - route type
 * @property {Array} [waypoints] - array of waypoints of route
 */
export const routePropType = PropTypes.shape({
    description: PropTypes.string,
    name: PropTypes.string,
    routeDistance: PropTypes.number,
    routeDuration: PropTypes.number,
    routeId: idPropType,
    routeParameters: routeParametersPropType,
    type: PropTypes.string,
    waypoints: PropTypes.arrayOf(waypointsPropType)
})
